module.exports = {"140322100":"秀水镇","140322101":"孙家庄镇","140322102":"路家村镇","140322103":"南娄镇","140322104":"牛村镇","140322105":"苌池镇","140322106":"上社镇","140322107":"西烟镇","140322200":"仙人乡","140322201":"北下庄乡","140322202":"下社乡","140322203":"梁家寨乡","140322204":"西潘乡","140322205":"东梁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140322.json
// module id = 255
// module chunks = 0